import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Notification, Interval } from '@model';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
 
  constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}

  getMyUnreadNotificationsCount(): Observable<number> {
    return this.http
      .get<number>(`${environment.apiEndpoint}/Notifications/Unread/Count`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getMyNotificationsCount(): Observable<number> {
    return this.http
      .get<number>(`${environment.apiEndpoint}/Notifications/Count`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  removeNotification(item: Notification): Observable<Notification> {
    return this.http
      .delete<any>(`${environment.apiEndpoint}/Notifications/${item.id}`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  bulkRemoveNotification(ids: number[]): Observable<boolean> {
    return this.http
      .post<boolean>(
        `${environment.apiEndpoint}/Notifications/bulkdelete`, ids)
        .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getMyNotifications(): Observable<Notification[]> {
    return this.http
      .get<Notification[]>(`${environment.apiEndpoint}/Notifications`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getMyNotificationsInterval(interval: Interval): Observable<Notification[]> {
    return this.http
      .post<Notification[]>(`${environment.apiEndpoint}/Notifications`, interval)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  getMyUnreadNotifications(): Observable<Notification[]> {
    return this.http
      .get<Notification[]>(`${environment.apiEndpoint}/Notifications/Unread`)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  setNotificationAsRead(notification: Notification): Observable<Notification> {
    return this.http
      .post<Notification>(`${environment.apiEndpoint}/Notifications/Unread/${notification.id}/read`, null)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }

  SetMyNotificationIntervalAsRead(interval: Interval): Observable<Notification[]> {
    return this.http
      .post<Notification[]>(`${environment.apiEndpoint}/Notifications/Unread/read`, interval)
      .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
  }
}
